import React, { useEffect, useRef, useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
  CircularProgress,
  Divider,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import clsx from 'clsx'
import classNames from 'classnames'
import CustomAlert from '../../CustomAlert'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider'
import { parseDate } from '../../Models/CommonFunc'
import { Helmet } from 'react-helmet'
import { getAllChemistUsersDocument } from '../../../Backend/firebase/supply-order'
import SupplyChemistDropdown from './SupplyChemistDropdown'
import { uploadExcelPdfInvoiceDocument, uploadInvoiceDocument } from '../../../Backend/firebase/collection-wholesaler'
import * as pdfjs from "pdfjs-dist";
pdfjs.GlobalWorkerOptions.workerSrc = "/assets/js/pdf.worker.js";

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function UploadExcelPdfInvoice() {
  const { register, handleSubmit, errors, reset, setValue } = useForm()
  const classes = useStyles()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [InvoiceDate, setInvoiceDate] = useState(parseDate(new Date()))
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const { userData } = CheckUserProvider()
  const [allChemist, setAllChemist] = useState([])
  const [selectedChemist, setSelectedChemist] = useState(null);
  const [InvoiceNo, setInvoiceNo] = useState('');
  const [netTotal, setNetTotal] = useState("");

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  useEffect(async () => {
    if (userData) {
      try {
        const getChemistDetails = await getAllChemistUsersDocument()
        setAllChemist(getChemistDetails)
      } catch (error) {
        console.log('Error Occur in Get Products And Sales', error)
      }
    }
  }, [userData])

  const onSubmit = async (data) => {
    console.log('on Tap Submit')
  }

  const extractNetTotal = async (file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = async function () {
      const typedarray = new Uint8Array(reader.result);
      const pdf = await pdfjs.getDocument({ data: typedarray }).promise;
      let extractedText = "";

      for (let i = 1; i <= pdf?.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page?.getTextContent();
        const textItems = textContent?.items?.map((item) => item.str);
        extractedText += textItems?.join(" ") + " ";
      }

      // Extract "Net Total" value
      const match = extractedText?.match(/Net Total\s*[:\-]?\s*\$?([\d,]+\.?\d{0,2})/i);
      if (match) {
        setNetTotal(match[1]);
      } else {
        setNetTotal("N/A");
      }
    };
  };

  const handleUploadSubmitSubmit = () => {
    if (selectedChemist && selectedChemist != null) {
      handleSubmit(async (data) => {
        if (data.invoiceDocument.length > 0) {
          const isConfirmed = window.confirm("Are you sure you want to upload invoice?");
          if (isConfirmed) {
            setIsLoading(true)
            var newInvoicePdf = {}
            newInvoicePdf.userId = userData.uid;
            newInvoicePdf.chemistUid = selectedChemist?.uid;
            newInvoicePdf.ChemistInfo = selectedChemist?.storeName;
            newInvoicePdf.TotalAmount = netTotal;
            newInvoicePdf.invoiceDate = data?.InvoiceDate;
            newInvoicePdf.invoiceNo = data.InvoiceNo;
            if (data.invoiceDocument.length > 0) {
              var invoicePath = null;
              invoicePath = `Invoice/${selectedChemist?.uid
                }/${selectedChemist?.storeName}_${Date.now()}.${data.invoiceDocument[0].name.split('.').pop()}`
              await uploadInvoiceDocument(invoicePath, data.invoiceDocument[0])
              newInvoicePdf.invoiceDocumentPath = invoicePath
            }
            try {
              var invoice = uploadExcelPdfInvoiceDocument(newInvoicePdf);
              if (invoice) {
                setNotificationMessage('Invoice Uploaded Successfully.')
                setOpenNotify(true)
                setAlertType('success')
                setIsLoading(false);
                setTimeout(() => { routeToPages() }, 2000)
              } else {
                console.error("ERROR Occurs in Create Invoice Database Entry => ");
                setNotificationMessage('Something went wrong, Please Try Again later!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
              }
            } catch (error) {
              console.error(error);
              setNotificationMessage('Something went wrong, Please try again later!!');
              setOpenNotify(true);
              setAlertType('error');
              setIsLoading(false);
            }
          } else {
            console.log("Form submission canceled.");
          }
        } else {
          setNotificationMessage('Please Choose Invoice File!')
          setOpenNotify(true)
          setAlertType('error')
          setIsLoading(false)
        }
      })()
    } else {
      setNotificationMessage('Please Select Chemist!')
      setOpenNotify(true)
      setAlertType('error')
      setIsLoading(false)
    }
  }

  const routeToPages = () => {
    history.push('/supply/all-excel-invoices');
  }

  const handleInvoiceDateChange = (e) => {
    setInvoiceDate(parseDate(e.target.value))
  }

  return (
    <>
      <div className="createProduct mt-2">
        <Helmet>
          <meta name="description" content="Generate Invoice" />
          <title>Generate Invoice | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <h5 className="mt-3">
                Upload Invoice: &nbsp;
              </h5>
              <div className="row mb-3">
                <div className="col-md-8 mb-2">
                  <div className="col-md-12 mb-3">
                    <SupplyChemistDropdown
                      data={allChemist}
                      setSelectedChemist={setSelectedChemist}
                    />
                  </div>
                </div>
                <div className="col-md-4 mb-2">
                  Invoice Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                  <span className="form-control registerEmp__textbox registerEmp__datePicker mt-1">
                    <DatePickerComponent
                      id="InvoiceDate"
                      name="InvoiceDate"
                      value={InvoiceDate}
                      cssclassName="e-outline"
                      onChange={(e) => handleInvoiceDateChange(e)}
                      className={classNames({ "is-invalid": errors.InvoiceDate })}
                      ref={register({ required: 'Please select generated Invoice Date!' })}
                      format="dd/MM/yyyy"
                      cleared={() => setInvoiceDate('')}
                    />
                  </span>
                  <small className="form-text text-danger">{errors.InvoiceDate && errors.InvoiceDate.message}</small>
                </div>
                <div className="col-md-4 mb-2">
                  Upload Invoice <small>(Please upload pdf)</small>
                  <input
                    type="file"
                    className={classNames('form-control registerEmp__textbox')}
                    name="invoiceDocument"
                    placeholder="Invoice(Accept only pdf)"
                    accept=".pdf"
                    ref={register}
                    onChange={(e) => extractNetTotal(e.target.files[0])}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  Invoice No
                  <input
                    type="text"
                    className={classNames(
                      'form-control registerEmp__textbox',
                    )}
                    name="InvoiceNo"
                    value={InvoiceNo}
                    onChange={(e) => setInvoiceNo(e.target.value)}
                    autoComplete="none"
                    ref={register()}
                  />
                </div>
              </div>

              <div className="col-sm-12 text-right mt-2">
                <div className="d-flex justify-content-center">
                  <div className="p-2">
                    <Button
                      type="submit"
                      name="saved"
                      value="saved"
                      variant="contained"
                      disabled={isLoading ? true : false}
                      onClick={handleUploadSubmitSubmit}
                      className="registerEmp__btnLogin save"
                    >
                      {isLoading ? <CircularProgress size={18} /> : 'Upload Invoice'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Paper>
      </div>
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default UploadExcelPdfInvoice
